module.exports = __webpack_public_path__ + "static/media/Edit_icon.bd24e009.svg";